<template>
  <div class="multi-label-text-cell">
    <div
      class="label-text"
      :key="`label_text_${i}`"
      v-for="(labelAndText, i) in labelsAndTexts"
    >
      <span class="label">{{ labelAndText.label }}</span>
      <span
        class="text"
        :class="{
          'ml-1': labelAndText.label,
          'font-bold': labelAndText.textIsBold
        }"
      >
        {{ labelAndText.text }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiLabelTextCell",
  props: {
    labelsAndTexts: Array
  }
};
</script>

<style scoped></style>
